export default __webpack_public_path__ + "static/media/Red-Rooster.466eae56.jpg";